var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artistes"},[_c('Hero',{attrs:{"title":_vm.heroTitle,"text":_vm.heroText,"background":_vm.heroBg}}),_c('div',{staticClass:"container"},[_c('Cards',{attrs:{"content":_vm.artistes}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }